import { ERROR_CODES } from '@/shared/constants/errors.js'
import AuthController from '../domain/controller.js'
import { EVENTS } from '../utils/constants.js'
import publishUserData from './publishUserData.js'
import saveUserInLocalData from './saveUserInLocalData.js'
import Commons from '@/shared/utils/commons.js'

async function makeLogin(context, payload) {
  console.log('🚀 ~ makeLogin ~ payload:', payload)
  const { events, networkRepo, localRepo, sendBugAlert } = context

  events.dispatch(EVENTS.APPLICATION_IS_WORKING)
  events.dispatch(EVENTS.LOGIN_STARTED)

  let user = null

  let loginPayload = { ...payload }
  const rawInput = (loginPayload.email || '').trim()

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const isEmail = emailRegex.test(rawInput)

  if (!isEmail && rawInput) {
    let digits = rawInput.replace(/\D/g, '')
    if (digits.startsWith('229')) {
      digits = digits.slice(3)
    }

    let finalPhone = ''
    if (digits.length === 10) {
      if (!digits.startsWith('01')) {
        events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
          title: 'Numéro invalide',
          body: 'Un numéro à 10 chiffres doit obligatoirement commencer par 01.',
          type: 'error',
        })
        events.dispatch(EVENTS.LOGIN_FINISHED)
        events.dispatch(EVENTS.APPLICATION_WORK_FINISHED)
        return { success: false, user: null }
      }
      finalPhone = `229${digits}`
    } else if (digits.length === 8) {
      finalPhone = `22901${digits}`
    } else {
      events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
        title: 'Numéro invalide',
        body: 'Le numéro de téléphone doit contenir au moins 8 chiffres (ou 10 chiffres commençant par 01).',
        type: 'error',
      })
      events.dispatch(EVENTS.LOGIN_FINISHED)
      events.dispatch(EVENTS.APPLICATION_WORK_FINISHED)
      return { success: false, user: null }
    }

    try {
      const fetchUrl = `https://api.monrapidoo.com/user/rapidoo-rider/all?group=ultraxeno&phoneNumber=${finalPhone}`
      const response = await fetch(fetchUrl)
      const data = await response.json()
      const usersData = data?.data || []
      const foundUser = Array.isArray(usersData) && usersData.length > 0 ? usersData[0] : null

      if (foundUser && foundUser.email) {
        loginPayload.email = foundUser.email
      } else {
        events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
          title: 'Utilisateur non trouvé',
          body: 'Aucun compte associé à ce numéro de téléphone.',
          type: 'error',
        })
        events.dispatch(EVENTS.LOGIN_FINISHED)
        events.dispatch(EVENTS.APPLICATION_WORK_FINISHED)
        return { success: false, user: null }
      }
    } catch (e) {
      console.error('Error fetching user by phone:', e)
    }
  }

  try {
    user = await AuthController.login(loginPayload, networkRepo, localRepo)
    console.log('🚀 ~ makeLogin ~ user:', user)

    events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title: `Connexion réussie`,
      body: `Bienvenue ${user.firstName || ''}`,
    })
  } catch (error) {
    console.log('🚀 ~ makeLogin ~ error:', error)

    let title = 'Erreur de connexion'
    let body =
      'Impossible de vous connecter. Veuillez réessayer plus tard.'

    switch (error?.code) {
      case ERROR_CODES.ACCESS_DENIED:
        title = 'Compte supprimé'
        body =
          error.message ||
          "Votre compte a été supprimé. Veuillez contacter le support pour plus d'informations."
        break

      case ERROR_CODES.INVALID_CREDENTIALS:
        title = 'Identifiants incorrects'
        body = 'L’email, numéro ou mot de passe entré est incorrect.'
        break

      case ERROR_CODES.NOT_FOUND:
        title = 'Utilisateur non trouvé'
        body = 'Aucun compte n’est associé à ces informations.'
        break

      case ERROR_CODES.SERVICE_UNAVAILABLE:
        title = 'Service temporairement indisponible'
        body =
          'Nos serveurs sont momentanément inaccessibles. Veuillez réessayer dans quelques instants.'
        break

      case ERROR_CODES.SERVER_ERROR:
      default:
        title = 'Erreur interne'
        body = 'Une erreur inattendue est survenue.'
        sendBugAlert(error)
        break
    }

    events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
      title,
      body,
      type: 'error',
    })
  }

  events.dispatch(EVENTS.LOGIN_FINISHED)
  events.dispatch(EVENTS.APPLICATION_WORK_FINISHED)

  if (!user) return { success: false, user }
  await saveUserInLocalData(context)
  await publishUserData(context)
  context.events.dispatch(EVENTS.USER_CONNECTED)

  // Sauvegarder dans Preferences natif
  try {
    const rawUserData = user?.getData ? user.getData() : user
    if (rawUserData) {
      await Commons.syncUserDataToPreferences(rawUserData)
    }
  } catch (e) {
    console.warn('Failed to sync user to Preferences:', e)
  }

  return { success: true, user }
}

export default makeLogin
